import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import type { Observable } from 'rxjs';
import type { Dictionaries } from '../../types';

@Injectable({ providedIn: 'root' })
export class DictionariesService {
  private readonly http = inject(HttpClient);

  load(): Observable<Dictionaries> {
    return this.http.get<Dictionaries>(`api/v1/court/dictionaries`);
  }
}
